export const IPV4 =
  /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;

export const isIPv4 = (value) => IPV4.test(String(value || "").trim());

export const toFlag = (value) =>
  value === true || value === 1 || value === "1" ? 1 : 0;

export const flagString = (value) => String(toFlag(value));

export const isFlagOn = (value) => toFlag(value) === 1;

export const isVlanId = (value) => {
  const n = Number(value);
  return Number.isInteger(n) && n >= 1 && n <= 4094;
};

export const isSsidName = (value) => {
  const s = String(value || "").trim();
  return s.length >= 1 && s.length <= 32;
};

export const isNetworkName = (value) => {
  const s = String(value || "").trim();
  return s.length >= 1 && s.length <= 255 && /^[a-zA-Z0-9 _-]+$/.test(s);
};

export const PERSONAL_WPA = [
  "WPA2 Personal",
  "WPA2 Personal Mixed",
  "WPA3 Personal",
  "WPA3 Personal Mixed",
];

export const isWpaPassword = (value) => {
  const s = String(value || "");
  return s.length >= 8 && s.length <= 63;
};

export const needsWpaPassword = (security) => PERSONAL_WPA.includes(security);

export const clampBeacon = (value) => {
  const n = Number(value);
  if (Number.isNaN(n)) return 100;
  return Math.min(300, Math.max(100, n));
};

export const asList = (value) => {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.response)) return value.response;
  if (Array.isArray(value?.data)) return value.data;
  if (Array.isArray(value?.devices)) return value.devices;
  return [];
};

export const asSwitchList = (value) => {
  const list = asList(value);
  if (list.length) return list;
  if (value?.serialNo || value?.serialNumber) return [value];
  if (
    Array.isArray(value?.portMembers) &&
    (value.portMembers[0]?.serialNo || value.portMembers[0]?.serialNumber)
  ) {
    return value.portMembers;
  }
  return [];
};

export const switchSerial = (device) =>
  device?.serialNo || device?.serialNumber || "";

const DOMAIN =
  /^(?=.{1,253}$)(?!-)(?:[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,63}$/;

export const isDomain = (value) => DOMAIN.test(String(value || "").trim());
